<template>
  <div>
      <section class="section-shaped my-0">
          <div class="shape shape-skew">
              <img src="/img/bkgrnd.jpg" class="img-fluid">
          </div>

            <div class="d-none d-lg-block container shape-container">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12">
                          <img src="/img/devconf_logo_white_poly.png" width="100%">
                          <center><h1 style="color:white">Virtual Venue</h1></center>
                        </div>
                    </div>
                </div>
            </div>

      </section>

      <section class="section section-lg pt-lg-0 mt--200">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="row row-grid">
                        <div class="col-lg-12">
                            <card class="border-0" shadow body-classes="py-5">
                              <p>Om deel te nemen aan het evenement, kun je inloggen met de persoonlijke inloggegevens die je eerder van ons hebt ontvangen via de mail</p>
                              <p>Problemen met de link in de e-mail? Ga dan via <a href="https://live.eventinsight.io/1385-devconf2021/virtualevent/" target="_blank">deze link</a> naar het platform en log in met de toegestuurde credentials. Let op: het inlogscherm zit verstopt onder het devConf logo</p>
                              <img src="/img/login.png" width="100%"/>
                              <p>Bij problemen kun je contact opnemen met: <a href="mailto: info@devconf.nl">info@devconf.nl</a></p>
                            </card>
                        </div>
                  </div>
                </div>
            </div>
          </div>
      </section>
  </div>
</template>

<script>
export default {
}
</script>
